import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { LocalStorageService } from './shared/service/localstorage.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private localStorageService: LocalStorageService, 
        private router: Router,
        private route: ActivatedRoute) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.localStorageService.isLoggedIn()) {
            return true;
        } else {
            this.route.data.subscribe(
                data => {
                  console.log(data);
                }
              );
            this.router.navigate(['/login']);
            return false;
        }
    }
}